import { MarketSegmentEnum } from '@vfmfe/foundations';
import { getMarketSegment } from '../../utils';

const VODAFONE_APPLICATION_ID = 'Digital';
const AMIGO_APPLICATION_ID = 'Digital Amigo';

export const getContentfulConfiguration = () => {
    return {
        applicationId:
            getMarketSegment() === MarketSegmentEnum.VODAFONE ? VODAFONE_APPLICATION_ID : AMIGO_APPLICATION_ID
    };
};

window.getContentfulConfiguration = getContentfulConfiguration;
